import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { forwardRef as R, useMemo as _, cloneElement as v } from "react";
import N from "classnames";
import { kebabCase as X } from "lodash";
import { MULTI_TO_COMPONENT as Y } from "./index.es5446.js";
import { MenuItemWrapper as Z } from "./index.es5445.js";
import t from "./index.es5447.js";
import { useTheme as K } from "./index.es173.js";
import { getAriaAttributes as k } from "./index.es504.js";
import { Thumbnail as S } from "./index.es119.js";
import { Divider as B } from "./index.es18.js";
import { MoreInfo as L } from "./index.es149.js";
import { ColorIndicator as D } from "./index.es26.js";
import { Skeleton as $ } from "./index.es65.js";
import { BodyText as P } from "./index.es487.js";
import { LockIcon as tt } from "./index.es295.js";
import { onKeyDownEnter as et } from "./index.es500.js";
const gt = R(
  ({
    Icon: d,
    Badge: U,
    description: o,
    label: c,
    entityColor: m,
    hasDivider: T,
    isSelected: s,
    isDisabled: r,
    isLocked: p,
    colorIndicator: I,
    RightIcon: M,
    testId: C,
    labelInfo: E,
    wrapperStyle: O,
    thumbnail: h,
    tooltip: q,
    multi: f,
    onClick: u,
    onKeyDown: x,
    onLockedClick: b,
    isLoading: l = !1,
    role: g = "menuitem",
    ...y
  }, z) => {
    const A = K(), n = `${C ? `${X(C)}-` : ""}multiline-item`, V = N(t.container, {
      [t.containerWithEntity]: !!m
    }), j = N(t.root, {
      [t.disabled]: r
    }), w = N(t.textContent, {
      [t.noLeftIcon]: !d,
      [t.textContentOneLiner]: o && String(o).split(`
`).length !== 2
    }), F = N(t.icon, {
      [t.hasThumbnail]: h,
      [t.hasEntity]: m,
      [t.oneLineDescription]: !String(o).includes(`
`)
    }), G = (a) => {
      x == null || x(a), et(a, u, !1);
    }, H = (a) => {
      p ? b == null || b(a) : u == null || u(a);
    }, J = _(() => g ? k(g, !!s) : {}, [g, s]), Q = _(() => {
      let a;
      if (m && (a = /* @__PURE__ */ e(
        D,
        {
          color: I,
          thickness: "thick",
          entityColor: m,
          disabled: r,
          testId: `${n}-color-indicator-${m}`
        }
      )), d && (a = v(d, {
        color: r ? "outline" : "blue",
        outline: r ? "disabled" : "default-gray"
      })), h) {
        const W = /* @__PURE__ */ e(
          S,
          {
            size: "medium",
            disabled: r,
            testId: `${n}-thumbnail`,
            ...h
          }
        );
        f ? a = W : a = /* @__PURE__ */ e("div", { className: t.thumbnailContainer, children: W });
      }
      return f ? /* @__PURE__ */ i("div", { className: t.thumbnailContainer, children: [
        v(Y[f], {
          checked: s,
          disabled: r,
          onCheckedChange: void 0
        }),
        a
      ] }) : a;
    }, [d, I, m, r, s, f, n, h]);
    return l ? /* @__PURE__ */ i(
      "div",
      {
        className: j,
        ref: z,
        "data-testid": n,
        style: O,
        ...y,
        children: [
          /* @__PURE__ */ i("div", { className: V, children: [
            /* @__PURE__ */ e(
              $,
              {
                isVisible: l,
                height: "18px",
                width: "18px",
                margin: `${A.spacings.xl} 0 0 0`,
                "aria-label": "skeleton loading for icon"
              }
            ),
            /* @__PURE__ */ i("div", { className: w, children: [
              /* @__PURE__ */ e("span", { className: t.topText, children: /* @__PURE__ */ e(
                $,
                {
                  isVisible: l,
                  height: "16px",
                  width: "calc(20%)",
                  margin: `0 0 ${A.spacings.s} 0`,
                  "aria-label": "skeleton loading for item label"
                }
              ) }),
              /* @__PURE__ */ e("span", { className: t.topText, children: /* @__PURE__ */ e(
                $,
                {
                  isVisible: l,
                  height: "16px",
                  width: "100%",
                  "aria-label": "skeleton loading for item description"
                }
              ) })
            ] })
          ] }),
          /* @__PURE__ */ e(B, { visible: T, margin: "0 12px" })
        ]
      }
    ) : /* @__PURE__ */ e(
      Z,
      {
        tooltip: q,
        testId: n + "-tooltip" || `${c}-item-tooltip`,
        children: /* @__PURE__ */ i(
          "div",
          {
            "aria-label": `${c} ${o}`,
            "aria-labelledby": `${c} ${o}`,
            "aria-disabled": r,
            "aria-details": p ? "Menu Item in locked state" : void 0,
            tabIndex: 0,
            className: j,
            ref: z,
            "data-testid": n,
            style: O,
            onKeyDown: l ? void 0 : G,
            "data-selected": s,
            onClick: l ? void 0 : H,
            ...y,
            ...J,
            children: [
              /* @__PURE__ */ i("div", { className: V, children: [
                /* @__PURE__ */ e("span", { className: F, children: Q }),
                /* @__PURE__ */ i("div", { className: w, children: [
                  /* @__PURE__ */ i("span", { className: t.topText, children: [
                    /* @__PURE__ */ e(
                      P,
                      {
                        size: "default",
                        isEllipsis: !0,
                        variant: s ? "bold" : "semi-bold",
                        element: "span",
                        color: r ? "disabled" : "primary",
                        "data-testid": `${n}-label`,
                        children: c
                      }
                    ),
                    !l && E && /* @__PURE__ */ e(L, { tooltip: E })
                  ] }),
                  /* @__PURE__ */ i("span", { className: t.topText, children: [
                    /* @__PURE__ */ e(
                      P,
                      {
                        size: "small",
                        variant: "regular",
                        element: "p",
                        color: r ? "disabled" : s ? "secondary" : "gray",
                        "data-testid": `${n}-description`,
                        children: o
                      }
                    ),
                    U
                  ] })
                ] }),
                (p || M) && /* @__PURE__ */ e("span", { className: t.icon, children: p ? /* @__PURE__ */ e(tt, { size: 16 }) : v(M, {
                  color: "outline",
                  outline: r ? "disabled" : "default-gray"
                }) })
              ] }),
              /* @__PURE__ */ e(B, { visible: T, margin: "0 12px" })
            ]
          }
        )
      }
    );
  }
);
export {
  gt as MultilineItem
};
//# sourceMappingURL=index.es79.js.map
